/* eslint-disable no-console */
import axios from 'axios';
import ReactPlayer from 'react-player';

/** VideoModal plays URLs through ReactPlayer, so validation has to agree with it.
 * Iframely will happily embed things ReactPlayer has no player for — Google Drive
 * share links, Dropbox, OneDrive — and those render a silent blank player.
 */
export const isPlayableVideoUrl = (url) => !!url && ReactPlayer.canPlay(url);

const useValidateUrl = () => {
  const KEY = process.env.REACT_APP_IFRAMELY_KEY;

  /** remove the web share permission */
  const sanitizeIframeHtml = (responsehtml) => responsehtml
    .replace(/allow="[^"]*web-share[^"]*"/g, 'allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"')
    .replace(/height:\s*0;/g, 'height: 100%;') /** Fix height issue; */
    .replace(/<iframe/g, '<iframe style="top: 0; left: 0; width: 100%; height: 100%; position: absolute; border: 0; border-radius: 4px;"');

  /** Check if the HTML contains an iframe or valid video element */
  const isIframeOrVideo = (htmlContent) => {
    const iframeRegex = /<iframe[^>]*>/i;
    const videoRegex = /<video[^>]*>/i;
    return iframeRegex.test(htmlContent) || videoRegex.test(htmlContent);
  };

  const handleValidateUrl = (
    url,
    setUrlValidationLoading,
    setPassedUrlValidation,
    setUrlValidationError,
  ) => {
    /** No point spending a network call on a URL the player can't play — bail early
     * so the coach gets immediate feedback instead of waiting out the timeout below.
     */
    if (!isPlayableVideoUrl(url)) {
      setUrlValidationLoading(false);
      setPassedUrlValidation(false);
      setUrlValidationError('URL not valid');
      return;
    }

    setTimeout(() => {
      axios.get(`https://iframe.ly/api/iframely?url=${encodeURIComponent(url)}&key=${KEY}`)
        .then(
          (res) => {
            if (res.data.html) {
            /** Sanitize the HTML before setting it */
              const sanitizedHtml = sanitizeIframeHtml(res.data.html);
              /** Only set HTML if it's an iframe or a video */
              if (isIframeOrVideo(sanitizedHtml)) {
                setUrlValidationLoading(false);
                setPassedUrlValidation(true);
              } else {
                setUrlValidationLoading(false);
                setPassedUrlValidation(false);
                setUrlValidationError('URL not valid');
              }
            }
            if (!res.data.html) {
              setUrlValidationLoading(false);
              setPassedUrlValidation(false);
              setUrlValidationError('URL not valid');
            } else if (res.error) {
              setUrlValidationLoading(false);
              setPassedUrlValidation(false);
              setUrlValidationError('URL not valid');
            }
          },
          (error) => {
            setUrlValidationLoading(false);
            setPassedUrlValidation(false);
            setUrlValidationError('URL not valid');
            console.log('url validation error:', error);
          },
        );
    }, 500);
  };

  return {
    handleValidateUrl,
    isPlayableVideoUrl,
  };
};

export default useValidateUrl;
